import OBase from './OBase';
import * as Geometry from '../geometry';
import * as GHMath from '../../math';

const epsilon = 1e-8;

export default class EJoinCurve extends OBase {
  distance (p0, p1) {
    let dx = p0.X - p1.X;
    let dy = p0.Y - p1.Y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  removeDuplicated (path) {
    for (let i = 0, n = path.length; i < n; i++) {
      let p0 = path[i];
      let p1 = path[(i + 1) % n];
      if (this.distance(p0, p1) < epsilon) {
        path.splice(i, 1);
        n--;
      }
    }

    return path;
  }

  join (curves) {
    let paths = [];

    while (curves.length > 0) {
      let current = curves.shift().map(p => p); // just copy

      let first = current[0];
      let last = current[current.length - 1];

      let found = false;

      for (let i = 0, n = curves.length; i < n; i++) {
        let other = curves[i];
        if (other.length > 0) {
          let first2 = other[0];
          let last2 = other[other.length - 1];

          let connected = false;
          // eslint-disable-next-line no-cond-assign
          if (connected = this.distance(last, first2) <= epsilon) {
            // connect to last forwarding : current - other
            // console.log('pat a', current, other)
            other.shift();
            current = this.removeDuplicated(current.concat(other));
            // eslint-disable-next-line no-cond-assign
          } else if (connected = this.distance(first, last2) <= epsilon) {
            // connect to first forwarding : other - current
            current.shift();
            current = this.removeDuplicated(other.concat(current));
            // console.log('pat b')
            // eslint-disable-next-line no-cond-assign
          } else if (connected = this.distance(last, last2) <= epsilon) {
            // connect to last backwarding : current - rehto
            other.pop();
            other.reverse();
            current = this.removeDuplicated(current.concat(other));
            // console.log('pat c')
            // eslint-disable-next-line no-cond-assign
          } else if (connected = this.distance(first, first2) <= epsilon) {
            // connect to first backwarding : rehto - current
            other.shift();
            other.reverse();
            // current = other.concat(current)
            current = this.removeDuplicated(other.concat(current));
            // console.log('pat d')
          }

          if (connected) {
            curves.splice(i, 1);
            found = true;
            break;
          }
        }
      }

      if (!found) {
        paths.push(current);
        // let points = current.map(p => new THREE.Vector3(p.X, 0, p.Y))
        // global.debugger.addPoints(points)
      } else {
        // curves.splice(0, 0, current)
        curves.push(current);
      }
    }

    return paths;
  }

  update () {
    let curvesTree = this.getCurveObjectInput('Curves');

    let output = this.outputs['Surface'].paramObject;
    let outTree = new Geometry.DataTree();

    for (let i = 0; i < curvesTree.branches.length; i++) {
      let crvs = [];
      for (let j = 0; j < curvesTree.branches[i].length; j++) {
        let curvePath = curvesTree.branches[i][j];
        for (let k = 0; k < curvePath.length; k++) {
          let crv = curvePath[k];
          crvs.push(crv);
        }
      }

      // console.log(crvs.map(crv => crv.map(p => p)))

      let joined = this.join(crvs);
      // console.log(joined)
      for (let j = 0; j < joined.length; j++) {
        let path = joined[j];
        if (GHMath.isClockwise(path)) {
          path.reverse();
        }
        outTree.add([path], curvesTree.paths[i]);

        // let points = path.map(p => new THREE.Vector3(p.X, 0, p.Y))
        // global.debugger.addPoints(points, new THREE.Color(j * 100))
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EJoinCurve.js